
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scuola-primaria",
      function () {
        return require("private-next-pages/scuola-primaria/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/scuola-primaria"])
      });
    }
  